<template>
  <b-container fluid>
    <div v-if="isLoading" class="text-center mt-5">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-else-if="header" class="iq-card mt-3">
      <div class="iq-card-header d-flex justify-content-between">
        <div class="iq-header-title">
          <h4 class="card-title">RPM Classification Detail: #{{ header.mrohId }} CIHUY</h4>
        </div>
        <div>
          <b-button @click="openEditForm" variant="warning" class="mr-2">Edit</b-button>
          <b-button @click="openDelete" variant="danger" class="mr-2">Delete</b-button>
          <b-button @click="$router.go(-1)" variant="secondary">Back</b-button>
        </div>
      </div>
      <div class="iq-card-body">
        <h5>Header Information</h5>
        <b-row>
          <b-col md="6">
            <p><strong>Company ID:</strong> {{ header.mrohCompId }}</p>
            <p><strong>Asset ID:</strong> {{ header.mrohMassId }}</p>
          </b-col>
          <b-col md="6">
            <p><strong>Device ID:</strong> {{ header.mrohDevcId }}</p>
            <p><strong>Start Time:</strong> {{ header.mrohStartTime | date }}</p>
            <p><strong>Status:</strong>
              <b-badge :variant="header.mrohStatus === 1 ? 'success' : 'danger'">
                {{ header.mrohStatus === 1 ? 'Active' : 'Inactive' }}
              </b-badge>
            </p>
          </b-col>
        </b-row>
        <hr/>
        <h5>Detail Configuration</h5>
        <b-table
          :items="details"
          :fields="detailFields"
          striped
          responsive="sm"
          class="text-center"
        >
        </b-table>
      </div>
    </div>

    <!-- Form Modal -->
    <b-modal v-model="displayForm" title="Edit RPM Classification" hide-footer size="lg">
      <RpmClassificationForm
        :data="header"
        :is-edit="true"
        @onSuccess="onFormSuccess"
        @onCancel="displayForm = false"
      />
    </b-modal>

    <!-- Delete Confirmation Modal -->
    <b-modal v-model="displayDeletion" title="Confirm Deletion" @ok="onConfirmDeletion">
      <p>Are you sure you want to delete this item?</p>
    </b-modal>

  </b-container>
</template>

<script>
import RpmOperationHeaderSvc from '@/services/RpmOperationHeaderSvc';
import RpmOperationDetailSvc from '@/services/RpmOperationDetailSvc';
import RpmClassificationForm from './Form.vue';

export default {
  name: 'RpmClassificationDetail',
  components: {
    RpmClassificationForm,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      header: null,
      details: [],
      detailFields: [
        { key: 'mrodName', label: 'Name' },
        { key: 'mrodRpmMax', label: 'Max RPM' },
        { key: 'mrodConsRate', label: 'Consumption Rate' },
      ],
      displayForm: false,
      displayDeletion: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      try {
        const headerPromise = RpmOperationHeaderSvc.getRpmOperationHeaderById(this.id);
        const detailPromise = RpmOperationDetailSvc.getRpmOperationDetailsByHeaderId(this.id, { page: 1, size: 100, 'orders[mrodName]': 'asc' });

        const [headerRes, detailRes] = await Promise.all([headerPromise, detailPromise]);

        this.header = headerRes.data.data;
        this.details = detailRes.data.data;
      } catch (error) {
        console.error('Failed to fetch classification details', error);
        this.$toast.error('Failed to load details.');
      } finally {
        this.isLoading = false;
      }
    },
    openEditForm() {
      this.displayForm = true;
    },
    openDelete() {
      this.displayDeletion = true;
    },
    onFormSuccess() {
      this.displayForm = false;
      this.fetchData();
    },
    async onConfirmDeletion() {
      this.isLoading = true;
      try {
        await RpmOperationHeaderSvc.deleteRpmOperationHeader(this.id);
        this.$toast.success('Item deleted successfully.');
        this.$router.push({ name: 'RpmClassification' });
      } catch (error) {
        console.error('Failed to delete item', error);
        this.$toast.error('Failed to delete item.');
      } finally {
        this.isLoading = false;
        this.displayDeletion = false;
      }
    },
  },
};
</script>
